// Загрузка ОДНОЙ партии по ссылке диплинка (открытие чужого разбора по startapp).
// lichess: официальный экспорт одной партии по id (CORS открыт, [%eval] в PGN) —
//   GET lichess.org/game/export/{id} с Accept: application/x-ndjson → одна строка
//   NDJSON, которую парсит штатный parseLichessNdjson.
// chess.com: единичного публичного эндпоинта по id нет — тянем последние партии ника
//   штатным сервисом и ищем id среди них (диплинк рождается из недавней партии).
import { fetchChessComCoachData } from '@ext/services/chess-apis';
import { parseLichessNdjson, type CoachGame } from '@ext/core/game-sources';
import type { DeeplinkRef } from '../core/deeplink';

async function fetchLichessGame(id: string, signal?: AbortSignal): Promise<CoachGame> {
  const qs = 'evals=true&pgnInJson=true&opening=true&moves=true&clocks=false';
  const res = await fetch(`https://lichess.org/game/export/${encodeURIComponent(id)}?${qs}`, {
    headers: { accept: 'application/x-ndjson' },
    signal,
  });
  if (res.status === 404) throw new Error('game_not_found');
  if (!res.ok) throw new Error(`API ${res.status}`);
  const game = parseLichessNdjson(await res.text())[0];
  if (!game) throw new Error('game_not_found');
  return game;
}

async function fetchChessComGame(nick: string, id: string, signal?: AbortSignal): Promise<CoachGame> {
  const data = await fetchChessComCoachData(nick, { signal });
  const game = data.games.find((g) => g.id === id);
  if (!game) throw new Error('game_not_found');
  return game;
}

/** Загрузить партию по ссылке диплинка. Бросает Error('game_not_found') при отсутствии. */
export function fetchGameByRef(ref: DeeplinkRef, signal?: AbortSignal): Promise<CoachGame> {
  return ref.site === 'lichess' ? fetchLichessGame(ref.id, signal) : fetchChessComGame(ref.nick, ref.id, signal);
}
